export default __webpack_public_path__ + "static/media/foto.63ea16ee.jpg";